import { useCallback } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useSelectedAccount } from '@ibk/shared-auth';
export function useDominioRewardsTracking() {
    const { selectedAccount } = useSelectedAccount();
    const companyName = selectedAccount?.companyName || '';
    const trackViewDominioRewards = useCallback((params) => {
        datadogRum.addAction(params.action_name, {
            company_name: companyName,
        });
    }, [companyName]);
    return { trackViewDominioRewards };
}
